import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFeatureIsOn } from 'src/common/growthbook';
import { useTrackEventMutation } from '../slices';

export const useReprofilingUser = (lastReprofileAt?: string) => {
  const reprofilingUsersIsEnabled = useFeatureIsOn('reprofiling-users') && lastReprofileAt;
  const [trackEvent] = useTrackEventMutation();

  const [isReprofilingModalOpen, setIsReprofilingModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash === '#reprofiling') {
      void trackEvent({
        event: 'reprofile-dashboard-notification-cta',
      });
      setIsReprofilingModalOpen(true);
      navigate(location.pathname, { replace: true });
    }
  }, [location.hash, location.pathname, navigate, trackEvent]);

  return {
    reprofilingUsersIsEnabled,
    isReprofilingModalOpen,
    setIsReprofilingModalOpen,
  };
};
